import { formatterPrice } from 'src/utils/formatterPrice'

import type { Product } from '../types/product'
import type { ProductItem } from '../types/productItem'

type ProductCardPriceV3Props = {
  product: Product
  currentSku: ProductItem
}

const ProductCardPriceV3 = ({ currentSku }: ProductCardPriceV3Props) => {
  const { cashDiscountPercentage, listPrice, cashPrice } =
    currentSku?.sellerDefault?.sellerOffer || {}

  return (
    <div className="product-card__content--price flex gap-1.5 items-center flex-wrap">
      <p className="font-inter text-sm md:text-[15px] text-restructure-primary font-bold leading-5 md:leading-6">
        {formatterPrice(cashPrice)}
        {cashDiscountPercentage > 0 && (
          <span className="text-sm ml-1 md:text-base"> a vista</span>
        )}
      </p>
      <p
        className={`font-inter font-regular text-xs md:text-sm items-center text-darkGray line-through leading-5 ${
          listPrice > cashPrice ? 'flex' : 'hidden'
        }`}
      >
        {formatterPrice(listPrice)}
      </p>
    </div>
  )
}

export default ProductCardPriceV3
